/**
 * Quem responde pelo Sancus perante a LGPD — o único lugar desses dados.
 *
 * A política de privacidade (e qualquer documento legal futuro) lê daqui:
 * trocar o e-mail do encarregado ou o endereço é editar este arquivo, e não
 * caçar o texto em várias páginas.
 *
 * LGPD, art. 9º: o titular tem direito de saber quem é o controlador e como
 * contatá-lo. Art. 41, §1º, e Resolução CD/ANPD nº 18/2024: a identidade e o
 * contato do encarregado são divulgados publicamente.
 */
export const LEGAL_ENTITY = {
  productName: 'Sancus',
  legalName: 'LAUREO TECNOLOGIA E SISTEMAS LTDA - ME',
  cnpj: '61.463.146/0001-68',
  address: {
    street: 'Rua Maria Luiza Bazzani Natal, 381, Casa 24 (condomínio)',
    district: 'Uberaba',
    city: 'Curitiba',
    state: 'PR',
    postalCode: '81540-540',
  },
  siteUrl: 'https://sancuscrm.com.br',
  /**
   * Encarregado pelo tratamento de dados (DPO). `name` é obrigatório pela
   * Resolução CD/ANPD nº 18/2024 — enquanto vazio, a página mostra o cargo.
   */
  dataProtectionOfficer: {
    name: 'Vinicius Guidotti Macedo',
    email: 'laureolabs@gmail.com',
  },
  /** Comarca eleita para disputas, ressalvado o foro do consumidor (CDC, art. 101, I). */
  forum: 'Curitiba/PR',
  /** Data de vigência da versão atual — atualizar a cada mudança do texto. */
  policyVersion: '1.1',
  policyEffectiveDate: '2026-10-13',
} as const;

export function formatLegalAddress(): string {
  const { street, district, city, state, postalCode } = LEGAL_ENTITY.address;
  return `${street}, ${district}, ${city}/${state}, CEP ${postalCode}`;
}

/** "12 de outubro de 2026". Em UTC: a data é de calendário, e o fuso do leitor não pode mudar o dia. */
export function formatPolicyEffectiveDate(): string {
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'long', timeZone: 'UTC' }).format(
    new Date(`${LEGAL_ENTITY.policyEffectiveDate}T00:00:00Z`),
  );
}
